"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyncRo = exports.Catalogue = exports.State = exports.Msn = exports.Telemetry = exports.LatestTelemetryUpdate = exports.SensorIdentifier = exports.NAMESPACE = exports.Prefs = void 0;
const effect_1 = require("effect");
const Unit = __importStar(require("../../../../unit"));
const capability_1 = require("../../capability");
const vendor_1 = require("../../vendor");
const _util_1 = require("../_util");
const Base = __importStar(require("../base"));
const failure_mode_1 = require("./failure-mode");
const Prefs = __importStar(require("./prefs"));
exports.Prefs = __importStar(require("./prefs"));
exports.NAMESPACE = 'Culligan.Device.Class.SyncRo';
const operatingModes = [
    'Standard',
    'Disabled',
    'Factory',
    'Fault',
    'Ota',
    'Startup',
    'Installation',
];
const powerProfiles = ['Standard'];
const logLevels = [
    'Debug',
    'Silent',
    'Warning',
    'Trace',
];
const connectivity = ['Cellular', 'Wi-Fi'];
const Connectivity = Base.makeConnectivity(exports.NAMESPACE, connectivity);
/**
 * Filter
 * syncro 2 -> 480 hours
 * syncro 4 -> 300 hours
 * syncro 8 => 150 hours
 */
// Membrane
const slots = [];
const alarms = {
    consumableBased: [],
    firmwareBased: [
        capability_1.Alarm.Flooding,
        // Alarm.FilterDepletion,
        // Alarm.FilterExhausted,
        capability_1.Alarm.LowFlow,
        capability_1.Alarm.InConductance,
        capability_1.Alarm.RoConductance,
        capability_1.Alarm.InPressure,
        capability_1.Alarm.LowPumpPressure,
        capability_1.Alarm.HighPumpPressure,
        capability_1.Alarm.LowInTemperature,
        capability_1.Alarm.HighInTemperature,
        capability_1.Alarm.InSensorFaulty,
        capability_1.Alarm.MachineError,
        capability_1.Alarm.OnOffTransducerDisconnected,
    ],
    telemetryBased: [],
};
const sensors = {
    /**
     * Analog inputs
     */
    // I01
    temp_water: capability_1.Telemetry.Sensor.Number({
        name: 'Water Temperature',
        type: capability_1.Telemetry.WaterTemperatureDecicelsius,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    // I02
    cond_in: capability_1.Telemetry.Sensor.Number({
        name: 'In Conductance',
        type: capability_1.Telemetry.WaterConductance,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    // I03
    cond_ro: capability_1.Telemetry.Sensor.Number({
        name: 'RO Conductance',
        type: capability_1.Telemetry.WaterConductance,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    // I04
    flow_ro: capability_1.Telemetry.Sensor.Number({
        name: 'RO Flow Rate',
        type: capability_1.Telemetry.FlowRateDeciliterPerMinute,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    // I05
    pres_in: capability_1.Telemetry.Sensor.Number({
        name: 'In Pressure',
        type: capability_1.Telemetry.WaterPressureDecibar,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    // I06
    pres_out: capability_1.Telemetry.Sensor.Number({
        name: 'Out Pressure',
        type: capability_1.Telemetry.WaterPressureDecibar,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    // I07
    pres_pump: capability_1.Telemetry.Sensor.Number({
        name: 'Pump Pressure',
        type: capability_1.Telemetry.WaterPressureDecibar,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    /**
     * Digital IO
     */
    // DIO1
    sw_in: capability_1.Telemetry.Sensor.Boolean({
        name: 'Digital pressure switch S8 status IN pressure',
        type: capability_1.Telemetry.Switch,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    // DIO2
    sw_out: capability_1.Telemetry.Sensor.Boolean({
        name: 'Digital pressure switch S5 status OUT pressure',
        type: capability_1.Telemetry.Switch,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    // DIO3
    sw_pump: capability_1.Telemetry.Sensor.Boolean({
        name: 'Digital pressure switch S7 status Pump pressure',
        type: capability_1.Telemetry.Switch,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    // DIO4
    stat_pump: capability_1.Telemetry.Sensor.Boolean({
        name: 'Pump output status',
        type: capability_1.Telemetry.ComponentEnabled,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    // DIO5
    stat_valve: capability_1.Telemetry.Sensor.Boolean({
        name: 'Valve output status',
        type: capability_1.Telemetry.ComponentEnabled,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    /**
     * Counters & Functions
     */
    // I08
    uptime: capability_1.Telemetry.Sensor.Number({
        name: 'Operating Hours',
        type: capability_1.Telemetry.Uptime,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
};
exports.SensorIdentifier = effect_1.Schema.Literal(...effect_1.Record.keys(sensors)).annotations({
    identifier: `${exports.NAMESPACE}.SensorIdentifier`,
});
exports.LatestTelemetryUpdate = effect_1.Schema.Record({ key: exports.SensorIdentifier, value: effect_1.Schema.DateFromNumber })
    .pipe(effect_1.Schema.partialWith({ exact: true }))
    .annotations({
    identifier: `${exports.NAMESPACE}.LatestTelemetryUpdate`,
});
const events = [];
exports.Telemetry = effect_1.Schema.Struct({
    temp_water: capability_1.Telemetry.WaterTemperatureDecicelsius.FromScalar,
    cond_in: capability_1.Telemetry.WaterConductance.FromScalar,
    cond_ro: capability_1.Telemetry.WaterConductance.FromScalar,
    flow_ro: capability_1.Telemetry.FlowRateDeciliterPerMinute.FromScalar,
    pres_in: capability_1.Telemetry.WaterPressureDecibar.FromScalar,
    pres_out: capability_1.Telemetry.WaterPressureDecibar.FromScalar,
    pres_pump: capability_1.Telemetry.WaterPressureDecibar.FromScalar,
    sw_in: capability_1.Telemetry.Switch.FromScalar,
    sw_out: capability_1.Telemetry.Switch.FromScalar,
    sw_pump: capability_1.Telemetry.Switch.FromScalar,
    stat_pump: capability_1.Telemetry.ComponentEnabled.FromScalar,
    stat_valve: capability_1.Telemetry.ComponentEnabled.FromScalar,
    uptime: capability_1.Telemetry.Uptime.FromScalar,
}).annotations({
    identifier: `${exports.NAMESPACE}.Telemetry`,
});
const DeviceTypeFromCode = effect_1.Schema.transformLiterals([685, 'Best'], [686, 'Good']).annotations({
    identifier: `${exports.NAMESPACE}.DeviceTypeFromCode`,
});
const RemainingPreFilterTime = effect_1.Schema.Int.pipe(effect_1.Schema.between(0, 1_009), Unit.Into(Unit.Time.Hour)).annotations({
    identifier: `${exports.NAMESPACE}.RemainingPreFilterTime`,
    description: 'How many hours of lifespan are left on the pre-filter',
});
exports.Msn = effect_1.Schema.String.pipe(effect_1.Schema.pattern(/^([A-Z]|\d|\s){9,16}$/)).annotations({
    identifier: `${exports.NAMESPACE}.Msn`,
});
exports.State = effect_1.Schema.Struct({
    ...Base.State.fields,
    operatingMode: effect_1.Schema.Literal(...operatingModes),
    powerProfile: effect_1.Schema.Literal(...powerProfiles),
    logLevel: effect_1.Schema.Literal(...logLevels),
    connectivity: effect_1.Schema.optionalWith(Connectivity, { exact: true }),
    deviceType: effect_1.Schema.optionalWith(DeviceTypeFromCode, { exact: true }),
    remainingPreFilterTime: effect_1.Schema.optionalWith(RemainingPreFilterTime, { exact: true }),
    msn: effect_1.Schema.optionalWith(exports.Msn, { exact: true }),
    sku: effect_1.Schema.optionalWith(effect_1.Schema.Null, { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.State`,
});
exports.Catalogue = (0, _util_1.makeCatalogue)(slots).annotations({
    identifier: `${exports.NAMESPACE}.Catalogue`,
});
const identifier = `${exports.NAMESPACE}.SyncRo`;
class SyncRo extends effect_1.Schema.Class(identifier)({
    model: effect_1.Schema.tag('ro1'),
    alarms: (0, _util_1.makeActiveAlarms)(alarms),
    consumables: (0, _util_1.makeSlottedConsumables)(slots),
    state: exports.State,
    latestTelemetry: effect_1.Schema.partialWith(exports.Telemetry, { exact: true }),
    latestTelemetryUpdate: effect_1.Schema.optionalWith(exports.LatestTelemetryUpdate, {
        exact: true,
        default: () => ({}),
    }),
    prefs: effect_1.Schema.optionalWith(Prefs.Prefs, { exact: true, default: () => Prefs.DEFAULT_PREFS }),
    vendor: vendor_1.ThinkWater.DeviceInfo,
    ...Base.CommonProps.fields,
}, { identifier }) {
    static code = 'ro1';
    static label = 'SyncRO';
    static category = 'Reverse-Osmosis';
    static operatingModes = operatingModes;
    static powerProfiles = powerProfiles;
    static logLevels = logLevels;
    static alarms = alarms;
    static slots = slots;
    static sensors = sensors;
    static events = events;
    static connectivity = connectivity;
    static connectionGateway = 'TartabitBridge';
    static image = null;
    static State = exports.State;
    static Prefs = Prefs.Prefs;
    static PrefsFromPartial = Prefs.PrefsFromPartial;
    static Telemetry = exports.Telemetry;
    static Catalogue = exports.Catalogue;
    static vendors = [vendor_1.ThinkWater.code];
    static init = (props, dates) => {
        return new this(Base.deviceInitProps({
            operatingMode: 'Startup',
            powerProfile: 'Standard',
            logLevel: 'Silent',
            connectivity: 'Cellular',
        }, slots, null, props, dates));
    };
    get code() {
        return `${this.vendor.code}${this.model}`;
    }
    get consumableAlarms() {
        return [];
    }
    get telemetryAlarms() {
        return [];
    }
    get manufacturingInfo() {
        return effect_1.Option.none();
    }
    get failureModes() {
        return (0, failure_mode_1.getFailureModes)(this);
    }
}
exports.SyncRo = SyncRo;
//# sourceMappingURL=index.js.map